<template>
  <div id="response-container">
    <h2>{{ title }}</h2>
    <p>{{ message }}</p>
    <IconSuccess v-show="success" id="icon-success" />
    <IconFail v-show="!success" id="icon-fail" />
    <Button
      v-if="showButton"
      class="mt-20"
      type="button"
      :text="buttonText"
      classtype="primary"
      @click="goTo(goToPage)"
    />
  </div>
  <slot> </slot>
</template>
<script setup>
import Button from "@/components/Button.vue"
import IconFail from "@/components/svg/circle-xmark.vue"
import IconSuccess from "@/components/svg/check-circle.vue"
import { DASHBOARD, goToDashboard, goToLogin } from "@/helpers/"
const props = defineProps(["success", "title", "message", "buttonText", "goToPage", "showButton"])

const emit = defineEmits({ click: String })

const goTo = (goToPage) => {
  emit("click")
  switch (goToPage) {
    case DASHBOARD:
      goToDashboard()
      break
    case LOGIN:
      goToLogin()
    default:
      break
  }
}
</script>
<style>
#response-container {
  max-width: 300px;
}

#icon-success,
#icon-fail {
  display: block;
  margin: auto;
  width: 40px;
}
</style>
